import Paper from '@mui/material/Paper';

function PaperComponent(props) {
  return <Paper {...props} elevation={0} />;
}

export default PaperComponent;
